import type { AuthRepository } from '~~/core/ports/repositories/AuthRepository';

import { Result } from '~~/core/helpers/result';
import { createOriginalErrorObject } from '~~/server/utils/errorHandling';

export const nuxtAuthRepository: AuthRepository = {
	async phone({ phoneNumber }) {
		try {
			const response = await $fetch('/api/auth/phone', {
				method: 'POST',
				body: { phoneNumber }
			});

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while sending the phone number for OTP verification.',
				source: 'nuxtAuthRepository.phone',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async getCreatePhoneUser(params) {
		try {
			const response = await $fetch('/api/auth/get-create-phone-user', {
				method: 'POST',
				body: params
			});

			if (!response) throw new Error('No response from server');

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while sending the phone number for OTP verification.',
				source: 'nuxtAuthRepository.getCreatePhoneUser',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async completeSocialRegistration(params) {
		try {
			const response = await $fetch('/api/auth/complete-social-registration', {
				method: 'POST',
				body: params
			});

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while trying to complete social registration.',
				source: 'nuxtAuthRepository.completeSocialRegistration',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async completePhoneRegistration(params) {
		try {
			const response = await $fetch('/api/auth/complete-phone-registration', {
				method: 'POST',
				body: params
			});

			if (!response) throw new Error('No response from server');

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while trying to complete phone registration.',
				source: 'nuxtAuthRepository.completePhoneRegistration',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	},
	async verifySocialRegistration(params) {
		try {
			const response = await $fetch('/api/auth/verify-social-registration', {
				method: 'POST',
				body: params
			});

			if (!response) throw new Error('No response from server');

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while trying verify OTP for social registration.',
				source: 'nuxtAuthRepository.verifySocialRegistration',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	}
};
